// extracted by mini-css-extract-plugin
export default {"input":"Aba-z","button":"Bba-z","selected":"Cba-z","unavailable":"Dba-z","oos":"Eba-z","paperCutDisabledOverlay":"Fba-z","image":"Gba-z"};